module.exports = __webpack_public_path__ + "static/media/webdev.e1a77a7b.jpg";